import { Link } from "react-router-dom";

const USE_CASE_LINKS = [
  { label: "AI Incident Management", href: "/ai-incident-management" },
  { label: "AIOps Incident Reasoning", href: "/aiops-incident-reasoning" },
  { label: "Root Cause Analysis AI", href: "/root-cause-analysis-ai" },
  { label: "Major Incident Management", href: "/major-incident-management" },
  { label: "IT Downtime Reduction", href: "/it-downtime-reduction" },
  { label: "Demo", href: "/demo" },
];

const LEGAL_LINKS = [
  { label: "Privacy Notice", href: "/trust#privacy" },
  { label: "Site Terms", href: "/trust#terms" },
  { label: "Security", href: "/trust#security" },
  { label: "Accessibility", href: "/trust#accessibility" },
  { label: "Contact", href: "/trust#contact" },
];

export default function Footer() {
  return (
    <footer
      data-testid="cre-footer"
      className="border-t border-slate-200 bg-white mt-auto"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-7 md:py-10 grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8">
        {/* Brand */}
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-gradient-to-br from-sky-500 via-cyan-500 to-violet-500">
              <span className="h-2.5 w-2.5 rounded-sm bg-white/90" />
            </span>
            <span className="font-heading font-black tracking-tight text-slate-900 text-sm">
              CRE — Collaborative Resolution Environment
            </span>
          </div>
          <p className="mt-2 text-[12px] text-slate-500 leading-relaxed">
            AI-powered Decision Intelligence Layer for modern IT operations.
          </p>
          <p className="mt-3 text-[12px] text-slate-600 leading-relaxed">
            Use anonymized information only. CRE provides advisory analysis and
            requires human validation.
          </p>
        </div>

        {/* Use Cases */}
        <div className="md:col-span-2">
          <div className="cre-overline text-slate-500">Use Cases</div>
          <ul className="mt-2.5 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5 text-[12.5px]">
            {USE_CASE_LINKS.map((l) => (
              <li key={l.label}>
                <Link
                  to={l.href}
                  data-testid={`footer-usecase-${l.href.replace(/^\//, "")}`}
                  className="text-slate-600 hover:text-sky-700 transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Legal links */}
        <div className="md:col-span-1">
          <div className="cre-overline text-slate-500">Resources</div>
          <ul className="mt-2.5 flex flex-col gap-1.5 text-[12.5px]">
            {LEGAL_LINKS.map((l) => (
              <li key={l.label}>
                <Link
                  to={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-slate-600 hover:text-sky-700 transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-1.5">
          <p className="text-[11px] text-slate-500 font-mono">
            © 2026 CRE Labs Ltd. All rights reserved.
          </p>
          <p className="text-[11px] text-slate-500">
            Advisory Mode — Human Approval Required
          </p>
        </div>
      </div>
    </footer>
  );
}
